module.exports = __webpack_public_path__ + "static/media/defaultUser.4d323cb8.svg";